module.exports = __webpack_public_path__ + "img/bg3.be1855c2.jpg";